"use client";

import type { FC, ReactNode } from "react";
import type { ThemeName } from "@huub-web/ui/theme/types";

import { DEFAULT_MENU_COLLAPSED_WIDTH } from "../../config/layoutConsts";
import { NavigationMenu } from "./NavigationMenu";

import { containerStyle, containerWrapperStyle } from "./DesktopNavigation.css";

type DesktopNavigationProps = {
  /**
   * Content rendered in the trailing section (avatar popup)
   */
  trailing?: ReactNode;
  /**
   * Whether navigation items are disabled
   */
  disabled?: boolean;
  /**
   * Active theme name
   */
  theme?: ThemeName;
  /**
   * Called when a navigation item is clicked
   */
  onNavigate?: (key: string) => void;
};

/**
 * Desktop sticky sidebar navigation.
 * Always renders at collapsed width (68px) with no width animation.
 */
export const DesktopNavigation: FC<DesktopNavigationProps> = ({
  trailing,
  disabled = false,
  theme = "light",
  onNavigate,
}) => {
  return (
    <div className={containerWrapperStyle}>
      <div
        className={containerStyle}
        style={{ width: DEFAULT_MENU_COLLAPSED_WIDTH }}
      >
        <NavigationMenu
          trailing={trailing}
          onNavigationChange={onNavigate}
          disabled={disabled}
          theme={theme}
          variant="default"
        />
      </div>
    </div>
  );
};
